import React, { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context'
import Viewbanner from '../../Admin/components/View_banner';
import Addbanner from '../../Admin/components/Add_banner'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Deletepopup from '../components/Delete_popup'
import SendNotifications from '../components/Send_Notifications'


const Notifications = () => {
    const columns = [
        { label: "S.No", field: "sno", },
        { label: "Title", field: "title", },
        { label: "Message", field: "message", },
        { label: "Success Count", field: "successcount", },
        { label: "Failure Count", field: "failurecount", },
        { label: "Created Date", field: "createddDate", },
    ];

    const title = { name: "Push Notifications", subheading: "Send Notifications to users", button: "Send Notifications" }
    //usestate define
    const { loading, setLoading } = useGlobalContext();
    const { openviewDialog, setopenviewDialog } = useGlobalContext();
    const { openDialog, setOpenDialog } = useGlobalContext();
    const { deleteDialog, setdeleteDialog } = useGlobalContext();
    const [edit, setEdit] = useState(false);
    const [banners, setBanners] = useState([]);
    const [getbanners, setGetbanners] = useState(false);
    const [selectedBanner, setSelectedBanner] = useState(null);
    const [totalpages, setTotalPages] = useState();
    const [currentPage, setCurrentPages] = useState(1);
    const [totalCount, setTotalcount] = useState();
    const rowsperpage = 10;

    //fetch banners
    const fetchBanners = async () => {
        const params = {
            page: currentPage,
            limit: rowsperpage,
        }
        try {
            const response = await instance.get('/Notifications/getNotification', { params })
            const formatteddata = response?.data?.data?.map((notification, index) => ({
                sno: index + 1,
                title: notification?.title ? notification?.title : "---",
                message: notification?.message ? notification?.message : "---",
                successcount: notification?.successCount ? notification?.successCount : "---",
                failurecount: notification?.failureCount ? notification?.failureCount : "0",
                createddDate: new Date(notification?.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                }),

            }))
            // console.log("response", response);

            setBanners(formatteddata);
            setTotalPages(response?.data?.pagination?.totalPages);
            setCurrentPages(response?.data?.pagination?.page);
            setTotalcount(response?.data?.pagination?.total);
        }
        catch (error) {
            console.log("error to fetch admins:", error.message)
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchBanners()
        setGetbanners(false)
        setLoading(true);
    }, [getbanners, currentPage])

    // Handle Row Click for Edit
    const handleEditClick = (banner) => {
        setSelectedBanner(banner);
        setEdit(true);
        setOpenDialog(true);
    };

    // Handle Row Click for view
    const handleViewClick = (banner) => {
        setSelectedBanner(banner);
        setopenviewDialog(true)
    }

    const handleDeleteClick = (banner) => {
        setSelectedBanner(banner);
        setdeleteDialog(true);
    };


    return (
        <div>
            <Topbar />
            <section className='admin-catalogue'>
                <PageHeader
                    search={'banners'}
                    title={title}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                />
                <SubHeader
                    menu={false}
                    filter={false}
                    openDialog={openDialog}
                    setopenviewDialog={setopenviewDialog}
                    setOpenDialog={setOpenDialog}
                />
                {loading ?
                    <div className='loader-section'>
                        <CircularProgress />
                    </div>
                    :
                    <CommonTable
                        columns={columns}
                        rows={banners}
                        openDialog={openDialog}
                        setOpenDialog={setOpenDialog}
                        openviewDialog={openviewDialog}
                        setopenviewDialog={setopenviewDialog}
                        edit={edit}
                        setEdit={setEdit}
                        handleEditClick={handleEditClick}
                        handleDeleteClick={handleDeleteClick}
                        handleViewClick={handleViewClick}
                        bannerdelete={true}
                        banner={true}
                        menu={true}
                        totalpages={totalpages}
                        rowsperpage={rowsperpage}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        setCurrentPages={setCurrentPages}
                    />
                }

                <SendNotifications
                    edit={edit}
                    setEdit={setEdit}
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    selectedBanner={selectedBanner}
                    setGetbanners={setGetbanners}
                />
            </section>
        </div>
    )
}

export default Notifications;
